<div mat-dialog-content class="content">
    <h3><b>Verificamos que você não fez nenhuma medição!</b></h3>
    <div class="row">
        <div class="col-md-12 text-warn">
            <b>Realmente deseja enviar sem as medições?</b>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <button mat-flat-button type="submit" class="btn-secudary btn-block" (click)="clickConfirm()">
                <span>Sim</span>
            </button>
        </div>
        <div class="col-md-6">
            <button mat-flat-button type="submit" color="primary" class=" btn-block" (click)="clickClose()">
                <span>Não</span>
            </button>
        </div>
    </div>
</div>